import React from 'react';

const Vue_Study_Plan = () => {
  return (
    <div>
      <h1>Vue_Study_Plan Component</h1>
      <p>This is the Vue_Study_Plan tutorial page.</p>
    </div>
  );
}

export default Vue_Study_Plan;
